import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "../pages/Login";
import Dashboard from "../pages/Dashboard";
import AdminLayout from "../layouts/AdminLayout";
import StateMaster from "../pages/masters/StateMaster";
import DistrictMaster from "../pages/masters/DistrictMaster";
import PlanCategoryMaster from "../pages/masters/PlanCategoryMaster";
import ProductCategoryMaster from "../pages/masters/ProductCategoryMaster";
import BannerManagement from "../pages/BannerManagement";
import TodayRate from "../pages/TodayRate";
import Products from "../pages/Products";
import Plans from "../pages/Plans";
import Users from "../pages/Users";
import Orders from "../pages/Orders";
import SalesEntry from "../pages/SalesEntry";
import Reports from "../pages/Reports";
import UserPlanList from "../pages/UserPlanList";
import UserEnquiryList from "../pages/UserEnquiry";
import BillingProducts from "../pages/BillingProducts";
import PurchaseEntry from "../pages/PurchaseEntry";
import EstimateEntry from "../pages/EstimateEntry";
import SalesbillMuthuoot from "../pages/SalesbillMuthuoot";

export default function AppRoutes() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Login />} />
                <Route element={<AdminLayout />}>
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/masters/state" element={<StateMaster />} />
                    <Route path="/masters/district" element={<DistrictMaster />} />
                    <Route path="/masters/plan-category" element={<PlanCategoryMaster />} />
                    <Route path="/masters/product-category" element={<ProductCategoryMaster />} />
                    <Route path="/banner" element={<BannerManagement />} />
                    <Route path="/today-rate" element={<TodayRate />} />
                    <Route path="/products" element={<Products />} />
                    <Route path="/plans" element={<Plans />} />
                    <Route path="/users" element={<Users />} />
                    <Route path="/orders" element={<Orders />} />
                    <Route path="/sales-entry" element={<SalesEntry />} />
                    <Route path="/reports" element={<Reports />} />
                    <Route path="/user-plan-list" element={<UserPlanList />} />
                    <Route path="/user-enquiry-list" element={<UserEnquiryList />} />
                    <Route path="/billing-products" element={<BillingProducts />} />
                    <Route path="/purchase-entry" element={<PurchaseEntry />} />
                    <Route path="/estimate-entry" element={<EstimateEntry />} />
                    <Route path="/salesbill-muthuoot" element={<SalesbillMuthuoot />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
}